import apiClient from "./client";

/**
 * Job Roles API Service
 */
export const jobRoleApi = {
  /**
   * Get all job roles with optional filters
   * @param {Object} params - Query parameters
   * @param {boolean} params.activeOnly - Filter to active roles only
   * @param {boolean} params.troncEligibleOnly - Filter to TRONC eligible roles only
   */
  getAll: (params = {}) => {
    return apiClient.get("/jobroles", params);
  },

  /**
   * Get job role by ID
   * @param {string} id - Job role ID (GUID)
   */
  getById: (id) => {
    return apiClient.get(`/jobroles/${id}`);
  },

  /**
   * Create a new job role
   * @param {Object} jobRole - Job role data
   */
  create: (jobRole) => {
    return apiClient.post("/jobroles", jobRole);
  },

  /**
   * Update a job role
   * @param {string} id - Job role ID
   * @param {Object} jobRole - Updated job role data
   */
  update: (id, jobRole) => {
    return apiClient.put(`/jobroles/${id}`, jobRole);
  },

  /**
   * Delete a job role
   * @param {string} id - Job role ID
   * @param {string} reason - Reason for deletion
   */
  delete: (id, reason = null) => {
    return apiClient.delete(`/jobroles/${id}`, reason ? { reason } : {});
  },

  /**
   * Sync job roles from an HR provider
   * @param {string} providerName - HR provider name (e.g., 'Sona')
   */
  syncFromProvider: (providerName) => {
    return apiClient.post(`/jobroles/sync/${providerName}`);
  },

  /**
   * Import job roles from a CSV file
   * @param {File} file - CSV file to import
   */
  importCsv: (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return apiClient.postFormData("/jobroles/import-csv", formData);
  },
};

export default jobRoleApi;
